<template>
  <div class="content" v-if="nRooms" @click.stop="getRoomsHide">
    <div class="slelect-floor" @click.stop>
      <div class="slelect-floor-head">请选择设备归属楼层</div>
      <div class="slelect-floor-content">
        <ul>
          <li
            :class="[nActiveFloorIndex === index ? 'active' : '']"
            v-for="(item, index) in objInfo.sub"
            :key="index"
            @click="selectTags(index)"
          >
            {{ oFloor[item.room] }}
          </li>
        </ul>
        <div class="btn-wrap">
          <button @click="closeFloorConfirm()">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    nRooms: {
      type: Boolean,
      default: false,
    },
    // 信息
    objInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      nActiveFloorIndex: 0,
      oFloor: {
        1: "一层",
        2: "二层",
        3: "三层",
        4: "四层",
        "-1": "地下室一层",
        "-2": "地下室二层",
      },
    };
  },
  methods: {
    selectTags(index) {
      this.nActiveFloorIndex = index;
    },
    closeFloorConfirm() {
      this.$emit('closeFloorConfirm',this.nActiveFloorIndex)
    },
    getRoomsHide(){
      this.$emit('update:nRooms',false);
    }
  },
};
</script>
<style lang="scss" scoped>
.content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.747);
  display: flex;
  align-items: center;
  justify-content: center;
  .slelect-floor {
    width: 660px;
    min-height: 485px;
    border-radius: 20px;
    background-color: #fff;
    padding: 30px;
    .slelect-floor-head {
      font-size: 34px;
      color: rgb(45, 45, 45);
      font-weight: bold;
    }
    .slelect-floor-content {
      margin-top: 30px;
      ul {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        li {
          background-color: rgb(247, 247, 253);
          border-radius: 55px;
          font-size: 30px;
          color: rgb(45, 45, 45);
          text-align: center;
          height: 70px;
          line-height: 70px;
          margin-right: 15px;
          width: 30%;
          margin-bottom: 30px;
        }
        li:last-child {
          margin-right: 0;
        }
        .active {
          border-width: 2px;
          border-color: rgb(44, 122, 236);
          border-style: solid;
          color: rgb(44, 122, 236);
          box-sizing: border-box;
        }
      }
    }
    .btn-wrap {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      button {
        width: 290px;
        height: 80px;
        background-color: #2f7fed;
        border-radius: 40px;
        font-size: 32px;
        color: #fff;
      }
    }
  }
}
</style>